module.exports = __webpack_require__.p + "2be80b0031bac7651957bcaa59539efb.jpg";